// noSpecialCharsDirective.js
export const noSpecialCharsDirective = {
    mounted(el, binding) {
        let isComposing = false;
        
        const inputHandler = (e) => {
            // 如果正在使用输入法组合，跳过处理
            if (isComposing) {
                return;
            }
            
            let moduleType = e.target.dataset.moduleType;
            let sanitizedValue;
            let value = e.target.value;
            if(moduleType == 'Partner' || moduleType == 'Customer' || moduleType == 'Merchant' || moduleType == 'Store'){
                sanitizedValue = value.replace(/[^\u4e00-\u9fa5\u00A2-\u017Eа-яА-Я-\w.…\-&()（）。'/@/ ]/g,'');
            }else{
                sanitizedValue = value.replace(/[^\u4e00-\u9fa5áéíóúüñÁÉÍÓÚÑÀ-ÿа-яА-Я-\w./ ]/g, '');
            }
            if (sanitizedValue !== value) {
                e.target.value = sanitizedValue;
                // 手动触发 input 事件以更新 v-model 绑定的值
                e.target.dispatchEvent(new Event('input'));
            }
        };
        
        // 监听输入法组合开始和结束事件
        const compositionStartHandler = () => {
            isComposing = true;
        };
        
        const compositionEndHandler = (e) => {
            isComposing = false;
            // 输入法组合结束后，检查最终结果
            inputHandler(e);
        };
        
        el.addEventListener('input', inputHandler);
        el.addEventListener('compositionstart', compositionStartHandler);
        el.addEventListener('compositionend', compositionEndHandler);
        
        // 保存处理程序以便在卸载时移除
        el.__inputHandler__ = inputHandler;
        el.__compositionStartHandler__ = compositionStartHandler;
        el.__compositionEndHandler__ = compositionEndHandler;
    },
    unmounted(el) {
        // 移除所有事件监听器
        el.removeEventListener('input', el.__inputHandler__);
        el.removeEventListener('compositionstart', el.__compositionStartHandler__);
        el.removeEventListener('compositionend', el.__compositionEndHandler__);
        delete el.__inputHandler__;
        delete el.__compositionStartHandler__;
        delete el.__compositionEndHandler__;
    }
};
